import ApiService from "@/_services/api/api.service";
import appConfig from "@/app-config";

ApiService.init(appConfig.VUE_APP_ROOT_API);

const GraycorpHelpdeskTimesheetService = {
  dataSourceConfig(url, params) {
    return ApiService.createDataSource(url, params);
  },

  getHeader(code) {
    return ApiService.oDataGet({
      url: "api/GraycorpHelpdeskTimesheet",
      filter: `TimesheetCode eq ${code}`,
      top: 1,
    });
  },

  getDetail(code) {
    return ApiService.oDataGet({
      url: "api/GraycorpHelpdeskTimesheetDetail",
      filter: `TimesheetCode eq ${code}`,
      orderby: "LineNo asc",
    });
  },

  save(payload) {
    return ApiService.post("api/Save_GraycorpHelpdeskTimesheet", payload);
  },
};

export { GraycorpHelpdeskTimesheetService };
